import React, { useEffect, useState } from "react";
import axios from "axios";


const Copyright = () => {
  const [copyrights, setCopyrights] = useState([]);

  useEffect(() => {
    fetchCopyrights();
  }, []);

  const fetchCopyrights = async () => {
    try {
      const res = await axios.get(
        `https://admin.stipsredu.in/copyright/all`
      );
      setCopyrights(res.data);
    } catch (error) {
      console.error("Error fetching copyrights", error);
    }
  };

  return (
    <section className="w-full bg-[#f8fafc] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-[#112E65] text-center mb-16">
          Institute Copyrights
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {copyrights.map((item, index) => (
            <div
              key={item._id}
              className={`bg-white shadow-xl p-8 border-l-8 border-[#112E65]
              ${
                index % 2 === 0
                  ? "rounded-tl-[50px] rounded-br-[50px]"
                  : "rounded-tr-[50px] rounded-bl-[50px]"
              }`}
            >
              <h3 className="text-xl font-bold text-[#112E65] mb-2">
                {item.title}
              </h3>

              <p className="text-sm text-gray-500 mb-2">
                Registration No:{" "}
                <span className="font-medium">
                  {item.registrationNumber}
                </span>
              </p>

              <p className="text-sm text-gray-500 mb-4">
                Author:{" "}
                <span className="font-medium">
                  {item.author}
                </span>
              </p>

              <p className="text-gray-600 leading-relaxed mb-6">
                {item.description}
              </p>

              <div className="inline-block px-4 py-1 rounded-full bg-[#112E65]/10 text-[#112E65] text-sm font-semibold">
                © {item.year} | {item.department}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Copyright;